import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/Index'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    name: 'Index',
    meta: { title: '首页', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/Index'], resolve),
    hidden: true
  },
  {
    path: '/agentBusiness',
    name: 'AgentBusiness',
    meta: { title: '代充业务', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/AgentBusiness'], resolve),
    hidden: true
  }, {
    path: '/apiDoc',
    name: 'ApiDoc',
    component: (resolve) => require(['@/views/whiteList/apiDoc/Index'], resolve),
    hidden: true,
    children: [
      {
        path: 'describe',
        name: 'Describe',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/Describe'], resolve),
        hidden: true
      },
      {
        path: 'submit/interFace',
        name: 'SubmitInterFace',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/SubmitInterFace'], resolve),
        hidden: true
      },
      {
        path: 'callback/interFace',
        name: 'CallbackInterFace',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/CallbackInterFace'], resolve),
        hidden: true
      },
      {
        path: 'query/interFace',
        name: 'QueryInterFace',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/QueryInterFace'], resolve),
        hidden: true
      }, {
        path: 'query/money',
        name: 'QueryMoney',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/QueryMoney'], resolve),
        hidden: true
      }, {
        path: 'product/code',
        name: 'ProductCode',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/ProductCode'], resolve),
        hidden: true
      }, {
        path: 'province/code',
        name: 'ProvinceCode',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/ProvinceCode'], resolve),
        hidden: true
      }, {
        path: 'appendix',
        name: 'Appendix',
        meta: { title: 'api文档', noCache: true, needRequest: false },
        component: (resolve) => require(['@/views/whiteList/apiDoc/Appendix'], resolve),
        hidden: true
      }
    ]
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    meta: { title: '联系我们', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/ContactUs'], resolve),
    hidden: true
  },
  {
    path: '/login',
    name: 'Login',
    meta: {title: '登录', noCache: true, needRequest: false},
    component: (resolve) => require(['@/views/whiteList/Login'], resolve),
    hidden: true
  },
  {
    path: '/regiest',
    name: 'Regiest',
    meta: { title: '注册', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/Regiest'], resolve),
    hidden: true
  },
  {
    path: '/regiestSucc',
    name: 'RegiestSucc',
    meta: { title: '注册成功', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/RegiestSucc'], resolve),
    hidden: true
  },
  {
    path: '/agreement',
    name: 'Agreement',
    meta: {title: '注册协议', noCache: true, needRequest: false},
    component: (resolve) => require(['@/views/whiteList/Agreement'], resolve),
    hidden: true
  },
  {
    path: '/findPassIndex',
    name: 'FindPassIndex',
    meta: { title: '找回密码', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/findPass/Index'], resolve),
    hidden: true
  },
  {
    path: '/findPass/second',
    name: 'FindPassSecond',
    meta: { title: '找回密码', noCache: true, needRequest: false },
    component: (resolve) => require(['@/views/whiteList/findPass/Second'], resolve),
    hidden: true
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: (resolve) => require(['@/views/Member'], resolve),
        meta: { title: '账单总览', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: 'query',
        name: 'query',
        component: (resolve) => require(['@/views/order/query'], resolve),
        meta: { title: '订单查询', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: (resolve) => require(['@/views/statistics/index'], resolve),
        meta: { title: '订单统计', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/exportrecord',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ExportRecord',
        component: (resolve) => require(['@/views/exportrecord'], resolve),
        meta: { title: '导出记录', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: (resolve) => require(['@/views/account/index'], resolve),
        meta: { title: '账户信息', icon: 'index', affix: true, noCache: true, needRequest: true }
      },
      {
        path: 'detail',
        name: 'index',
        component: (resolve) => require(['@/views/account/detail'], resolve),
        meta: { title: '账户明细', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/apply',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: (resolve) => require(['@/views/apply/index'], resolve),
        meta: { title: '申请充值', icon: 'index', affix: true, noCache: true, needRequest: true }
      },
      {
        path: 'record',
        name: 'record',
        component: (resolve) => require(['@/views/apply/record'], resolve),
        meta: { title: '申请充值', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/password',
    component: Layout,
    children: [
      {
        path: 'update',
        name: 'update',
        component: (resolve) => require(['@/views/password/update'], resolve),
        meta: { title: '修改密码', icon: 'index', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/login',
    component: Layout,
    children: [
      {
        path: 'log',
        name: 'log',
        component: (resolve) => require(['@/views/login/log'], resolve),
        meta: { title: '登录日志', icon: 'login', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '/operate',
    component: Layout,
    children: [
      {
        path: 'log',
        name: 'log',
        component: (resolve) => require(['@/views/operate/log'], resolve),
        meta: { title: '操作日志', icon: 'operation', affix: true, noCache: true, needRequest: true }
      }
    ]
  },
  {
    path: '*',
    component: (resolve) => require(['@/views/features/404'], resolve),
    hidden: true
  }
]

export default new Router({
  // mode: 'hash',
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/routers.js